import React from 'react';
import axios from 'axios'
import { Layout, Modal, DatePicker, Card, Carousel, Row, Col, Descriptions, Tabs, Button, Divider, Statistic, Form, Input, InputNumber, Space, message, Alert, Spin, Select, Table, Dropdown, Menu, Result } from 'antd';
import MaoliangEdit from 'containers/member/maoliangEdit';
import MemberPwdEdit from 'containers/member/memberPwdEdit';
import { layout, tailLayout } from 'containers/common/layout';
import moment from 'moment';
import '../../form.css';

import {
    UserOutlined,
    EditOutlined,
    GoldOutlined,
    EyeOutlined,
    ReloadOutlined,
    DownOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Content } = Layout;
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

export default class HotelAgentDetail extends React.Component {

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(props: any) {
        super(props);
    }

    state = {

        detail: [],
        plansResult: [],
        plansList: [],
        plansLoading: false,

        memberOrders: [],
        memberDetail: [],
        total: 0,
        loading: true,
        orderLoading: true,
        pwdEditorVisible: false,
        pwdEditorTitle: '重置密码',
        maoliangEditorVisible: false,
        maoliangEditorTitle: '赠送猫粮',
        dataId: 0,

        maoliangLoading: false,
        maoliangRecords: [],
        totalMaoliang: 0,

        shareRecordsLoading: false,
        shareRecords: [],
        shareRecordsTotal: 0,

        commentsLoading: false,
        comments: [],
        commentsTotal: 0,
    };

    orderColumns = [
        {
            title: '订单编号',
            dataIndex: 'orderId',
            width: '8%'
        },
        {
            title: '预订行程',
            dataIndex: 'tripName',
            width: '20%'
        },
        {
            title: '订单状态',
            dataIndex: 'status',
        },
        {
            title: '下单时间',
            dataIndex: 'orderTime',
        },
        {
            title: '操作',
            dataIndex: 'userId',
            render: (text: React.ReactNode) => <Link to={{ pathname: `members/detail/${text}` }} target="_blank"><Button shape="round" key={`a-${text}`}><EyeOutlined />查看</Button></Link>,
        }
    ];


    plansColumns = [
        {
            title: '套餐',
            dataIndex: 'RatePlanName',
        },
        {
            title: '床型',
            dataIndex: 'BedType',
        },
        {
            title: '早餐类型',
            dataIndex: 'BreakfastType',
        },
        {
            title: '可入住人数',
            dataIndex: 'MaxOccupancy',
        },
        {
            title: 'Price',
            dataIndex: 'TotalPrice',
            render: (text: any, record: any) => {
                return (
                    <div>{text} {record.Currency}</div>
                )
            }
        },
        {
            title: 'Rooms',
            dataIndex: 'RatePlanID',
            render: () => {
                return (
                    <Select defaultValue="1" style={{ width: 120 }} size="small" >
                        <Option value="1">1 room</Option>
                        <Option value="2">2 rooms</Option>
                        <Option value="3">3 rooms</Option>
                        <Option value="4">4 rooms</Option>
                        <Option value="5">5 rooms</Option>
                    </Select>
                )
            }
        },
        {
            title: '预订',
            dataIndex: 'RatePlanID',
            render: (record: any) => {
                return (
                    <Button type="primary" size="small">预订</Button>
                )
            }
        }
    ];

    shareRecordsColumns = [
        {
            title: '项目',
            dataIndex: 'tripName',
        },
        {
            title: '查看/购买人',
            dataIndex: 'user',
        },
        {
            title: '类型',
            dataIndex: 'type',
        },
        {
            title: '猫粮',
            dataIndex: 'maoliang',
        },
        {
            title: '状态',
            dataIndex: 'status',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
        }
    ];

    commentsColumns = [
        {
            title: '商品',
            dataIndex: 'tripName',
        },
        {
            title: '评价',
            dataIndex: 'comment',
            width: '50%',
        },
        {
            title: '评分',
            dataIndex: 'score',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
        }
    ];

    getDescription = () => {
        axios.get('http://192.168.100.76:5000/hotel/detail', {
            params: {
                hotelID: 1481
            }
        })
            .then((res) => {
                console.log('res', res.data)
                this.setState({
                    detail: res.data,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getPlans = () => {
        this.setState({
            plansLoading: true
        });
        axios.get('http://192.168.100.76:5000/hotel/plans', {
            params: {
                "hotelID": 1481
            }
        })
            .then((res) => {
                console.log('planslist', res.data.PriceDetails.HotelList)
                this.setState({
                    plans: res.data,
                    plansList: res.data.PriceDetails.HotelList[0].RatePlanList,
                    plansLoading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getMaoliang = () => {
        this.setState({
            maoliangLoading: true
        });
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/maoliang/list', {
            params: {}
        })
            .then((res) => {
                console.log('res orders', res.data.data.list)
                this.setState({
                    maoliangRecords: res.data.data.list,
                    totalMaoliangRecords: res.data.data.total,
                    maoliangLoading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getShareRecords = () => {
        this.setState({
            shareRecordsLoading: true
        });
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/shareRecords/list', {
            params: {}
        })
            .then((res) => {
                this.setState({
                    shareRecords: res.data.data.list,
                    shareRecordsTotle: res.data.data.total,
                    shareRecordsLoading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getComments = () => {
        this.setState({
            commentsLoading: true
        });
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/comments/list', {
            params: {}
        })
            .then((res) => {
                this.setState({
                    comments: res.data.data.list,
                    commentsTotal: res.data.data.total,
                    commentsLoading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // 打开 Modal
    showModal = (name: string) => {
        if (name == 'maoliangEditorVisible') {
            this.setState({
                maoliangEditorVisible: true
            })
        } else if (name == 'pwdEditorVisible') {
            this.setState({
                pwdEditorVisible: true
            })
        }
    };

    // 关闭 Modal
    cancelModal = (name: string) => {
        if (name == 'maoliangEditorVisible') {
            this.setState({
                maoliangEditorVisible: false
            })
        } else if (name == 'pwdEditorVisible') {
            this.setState({
                pwdEditorVisible: false
            })
        }
    };

    // 提交表单
    onFinish = (values: any) => {
        message.info("提交了表单: " + JSON.stringify(values));
        console.log('values', values);
    };

    // 切换Tab
    onTabsClick = (value: any) => {
        if (value === 'description') {
            console.log('tabs', value);
            this.getDescription();
        } else if (value === 'maoliang') {
            this.getMaoliang();
        } else if (value === 'shareRecords') {
            this.getShareRecords();
        } else if (value === 'comments') {
            this.getComments();
        }
    }

    onChange = (value: any) => {
        console.log('value', value);
        this.showModal(value.key);
    }


    componentDidMount() {
        this.getDescription();
        this.getPlans();
    }

    render() {
        let detail: any = this.state.detail;
        let description: any = detail.HotelDescription;

        if (description) {
            console.log('description', description[0])
        }

        const dateFormat = 'YYYY/MM/DD';
        const monthFormat = 'YYYY/MM';

        const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

        return (
            <div>
                <Content
                    style={{
                        padding: 24,
                        background: '#fff',
                        minHeight: 680,
                    }}
                >
                    <Row>
                        <Col span={18}>
                            <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                                <Row>
                                    <Col span={8}>
                                        <Carousel autoplay effect="fade">
                                            {
                                                detail['HotelImage'] && detail['HotelImage'].map((item: any, key: any) => {
                                                    if (key < 10) {
                                                        return (
                                                            <div>
                                                                <img src={item.ImageUrl} height="260" />
                                                            </div>
                                                        )
                                                    }

                                                })
                                            }
                                        </Carousel>
                                    </Col>
                                    <Col span={16}>
                                        <Descriptions title={`ID: ${detail.HotelID} ${detail.Name} ${detail.Name_CN}`}>
                                            <Descriptions.Item label="电话">{detail.Telephone}</Descriptions.Item>
                                            <Descriptions.Item label="星级">{detail.StarRating}</Descriptions.Item>
                                            <Descriptions.Item label="更新时间">{detail.UpdateDate}</Descriptions.Item>
                                            <Descriptions.Item label="Addr">{detail.Address_CN}, {detail.CityName_CN}, {detail.CountryName_CN}</Descriptions.Item>
                                        </Descriptions>
                                    </Col>

                                </Row>
                            </Spin>
                            <div style={{ "marginTop": "20px", "marginBottom": "20px" }}>
                                <Card>
                                    <Space size="large">
                                        <RangePicker
                                            defaultValue={[moment('2020/08/01', dateFormat), moment('2020/08/01', dateFormat)]}
                                            format={dateFormat}
                                        />

                                        <Select defaultValue="2" style={{ width: 120 }} >
                                            <Option value="1">1 adult</Option>
                                            <Option value="2">2 adults</Option>
                                            <Option value="3">3 adults</Option>
                                        </Select>

                                        <Select defaultValue="0" style={{ width: 120 }} >
                                            <Option value="0">no children</Option>
                                            <Option value="1">1 child</Option>
                                            <Option value="2">2 children</Option>
                                        </Select>



                                        <Button type="primary" onClick={() => { this.getPlans() }}>Search</Button>

                                    </Space>
                                </Card>
                                <Spin tip="Loading..." size="large" spinning={this.state.plansLoading}>
                                    <Table
                                        size="small"
                                        columns={this.plansColumns}
                                        dataSource={this.state.plansList}
                                        pagination={{
                                            total: this.state.plansList.length,
                                            position: ["bottomLeft"],
                                        }}
                                        style={{ "marginTop": "20px" }}
                                    />
                                </Spin>
                            </div>
                            <Tabs defaultActiveKey="description" onTabClick={this.onTabsClick}>
                                <TabPane tab="介绍" key="orders">

                                    <h2>Description</h2>
                                    {
                                        description &&
                                        (
                                            <div dangerouslySetInnerHTML={{ __html: description[0]['HotelDescription_CN'] }} ></div>
                                        )
                                    }

                                    <h2>Hotel Facilities</h2>
                                    {
                                        detail['Facilities'] &&
                                        (
                                            detail['Facilities'].map((item: any, key: any) => {
                                                if (item.Type === 'HotelFacility') {
                                                    return (
                                                        <Space size="large"><Button type="link">{item.Description_CN}</Button></Space>
                                                    )
                                                }
                                            })
                                        )
                                    }


                                    <h2>Room Facilities</h2>
                                    {
                                        detail['Facilities'] &&
                                        (
                                            detail['Facilities'].map((item: any, key: any) => {
                                                if (item.Type === 'RoomFacility') {
                                                    return (
                                                        <Space size="large"><Button type="link">{item.Description_CN}</Button></Space>
                                                    )
                                                }
                                            })
                                        )
                                    }

                                    <h2>Policy</h2>
                                    {
                                        detail['Policy'] &&
                                        (
                                            detail['Policy'].map((item: any, key: any) => {
                                                if (item.Type === 'General') {
                                                    return (
                                                        <div dangerouslySetInnerHTML={{ __html: item.Description_CN }} ></div>
                                                    )
                                                } else {
                                                    return (
                                                        <Space size="large"><Button type="link">{item.Description_CN}</Button></Space>
                                                    )
                                                }

                                            })
                                        )
                                    }

                                    <h2>Availability</h2>


                                </TabPane>
                                <TabPane tab="猫粮" key="maoliang">
                                    <Spin tip="Loading..." size="large" spinning={this.state.maoliangLoading}>
                                        {/* <Table
                                            size="small"
                                            columns={this.maoliangColumns}
                                            dataSource={this.state.maoliangRecords}
                                            pagination={{
                                                total: this.state.totalMaoliang,
                                                position: ["bottomLeft"],
                                            }}
                                        /> */}
                                    </Spin>
                                </TabPane>
                                <TabPane tab="分享记录" key="shareRecords">
                                    <Spin tip="Loading..." size="large" spinning={this.state.shareRecordsLoading}>
                                        <Table
                                            size="small"
                                            columns={this.shareRecordsColumns}
                                            dataSource={this.state.shareRecords}
                                            pagination={{
                                                total: this.state.shareRecordsTotal,
                                                position: ["bottomLeft"],
                                            }}
                                        />
                                    </Spin>
                                </TabPane>
                                <TabPane tab="评价" key="comments">
                                    <Spin tip="Loading..." size="large" spinning={this.state.commentsLoading}>
                                        <Table
                                            size="small"
                                            columns={this.commentsColumns}
                                            dataSource={this.state.comments}
                                            pagination={{
                                                total: this.state.commentsTotal,
                                                position: ["bottomLeft"],
                                                pageSize: 5

                                            }}
                                        />
                                    </Spin>
                                </TabPane>
                            </Tabs>
                        </Col>
                        <Col span={6}>

                        </Col>
                    </Row>
                </Content>

                <MaoliangEdit dataId={this.state.dataId} editorVisible={this.state.maoliangEditorVisible} editorTitle={this.state.maoliangEditorTitle} onCancel={this.cancelModal.bind(this, 'maoliangEditorVisible')} ref="child"></MaoliangEdit>

                <MemberPwdEdit dataId={this.state.dataId} editorVisible={this.state.pwdEditorVisible} editorTitle={this.state.pwdEditorTitle} onCancel={this.cancelModal.bind(this, 'pwdEditorVisible')} ref="child"></MemberPwdEdit>
            </div>
        )
    }
}
